module.exports = __webpack_public_path__ + "img/cafe.9a0c2174.jpeg";